import { createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';
import {
  PushNotificationErrors,
  PushNotificationFormState,
  PushNotificationResponse,
} from '../types';

type PushNotificationState = {
  formState: PushNotificationFormState;
  isLoading: boolean;
  response: PushNotificationResponse | null;
  error: string | null;
  errors: PushNotificationErrors;
};

const initialState: PushNotificationState = {
  formState: {
    customerId: '',
    notification: '',
    driverId: [],
    command: '',
  },
  isLoading: false,
  response: null,
  error: null,
  errors: {},
};

const pushNotificationSlice = createSlice({
  name: 'pushNotification',
  initialState,
  reducers: {
    setCustomerId: (state, action: PayloadAction<string>) => {
      state.formState.customerId = action.payload;
    },
    setNotification: (state, action: PayloadAction<string>) => {
      state.formState.notification = action.payload;
    },
    setDriverId: (
      state,
      action: PayloadAction<typeof initialState.formState.driverId>,
    ) => {
      state.formState.driverId = action.payload;
    },
    setCommand: (state, action: PayloadAction<string>) => {
      state.formState.command = action.payload;
    },

    sendNotificationStart: state => {
      state.isLoading = true;
      state.error = null;
      state.response = null;
      state.errors = {};
    },
    sendNotificationSuccess: (
      state,
      action: PayloadAction<PushNotificationResponse>,
    ) => {
      state.isLoading = false;
      state.response = action.payload;
    },
    sendNotificationFailure: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    setErrors: (state, action: PayloadAction<PushNotificationErrors>) => {
      state.errors = action.payload;
    },
    setResetData: () => initialState,
  },
});

export const { actions: pushNotificationActions } = pushNotificationSlice;

const selectPushNotification = (state: RootState) => state.pushNotification;

export const selectPushNotificationForm = createSelector(
  selectPushNotification,
  state => state.formState,
);

export const selectIsLoading = createSelector(
  selectPushNotification,
  state => state.isLoading,
);

export const selectResponse = createSelector(
  selectPushNotification,
  state => state.response,
);

export const selectError = createSelector(
  selectPushNotification,
  state => state.error,
);

export const selectErrors = createSelector(
  selectPushNotification,
  state => state.errors,
);

export default pushNotificationSlice.reducer;
